import { PresetVisibility } from '@aibees/shared/definition';

export const tabs = [
  { label: 'All', value: PresetVisibility.ALL },
  { label: 'Mine', value: PresetVisibility.PRIVATE },
  { label: 'Shared', value: PresetVisibility.INTERNAL },
];
